import RegimeApiService from '../../../../services/api/RegimeApiService';
import UtilService from "../../../../services/util";
import store from '../../../../store';
import { storeRegimes } from "../../../../store/actions/dadosActions";

/** 
 * Informações das colunas para lista de cargas horárias
 * @type {{
 *   groups: Array<{
 *      header: string,
 *      shouldRender: Function,
 *      fields: Array<{
 *        label: string,
 *        placeholder: string,
 *        name: string,
 *        type: string,
 *        size: number,
 *        className: string
 *      }>
 *   }
 * }>} 
*/

export const getFormFields = async () => {
    // REDUX
    const { dados } = store.getState();

    const [regimeData ] = await Promise.all([
        dados.regimes || (RegimeApiService.getAll()).then(resp => resp.data.data),
    ])

    // UPDATE REDUX ?
    if (!dados.regimes) {
        store.dispatch(storeRegimes(regimeData))
    }

    return {
        groups: [
            {
                header: '',
                fields: [
                    {
                        label: 'Código',
                        placeholder: '',
                        name: 'cod',
                        type: 'text',
                        size: 3,
                        readOnly: true,
                    },
                    {
                        label: 'Hora por Dia',
                        placeholder: 'Ex: 8h',
                        name: 'hora_dia',
                        type: 'number',
                        max: 24,
                        size: 3,
                    },
                    {
                        label: 'Hora Total no Mês',
                        placeholder: 'Ex: 200h',
                        name: 'hora_total',
                        type: 'number',
                        size: 3,
                    },
                    {
                        label: 'Regime Contrato',
                        placeholder: '',
                        name: 'id_regime',
                        type: 'select',
                        size: 2,
                        options: [
                            { value: '', label: '...' },
                            ...(regimeData
                                .sort((a,b) => UtilService.sortArrCallback(a,b,'nome'))
                                .map(item => ({
                                    value: item.cod,
                                    label: `${item.sigla} - ${item.nome}`
                                }))
                            )
                        ],
                    }
                ]
            }
        ]
    }
}

const ColaboradorViewInfo = { getFormFields };

export default ColaboradorViewInfo;